import { styled } from '@mui/material/styles';
import Link from '../../../../elements/Link';

export const StyledReviews = styled('div')(
  () => `
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 12px;
    line-height: 17px;
    
    & > img {
      max-width: 50px;
    }
  `,
);

export const StyledRatingContainer = styled('div')(
  () => `
    max-width: 145px;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
  `,
);

export const StyledRating = styled('div')(
  () => `
    margin: 0px 0 2px;
    display: flex;
    align-items: center;
  
    .gatsby-image-wrapper {
      margin-right: 10px;
    }
  
    span {
      font-weight: 600;
    }
  `,
);

export const StyledLink = styled(Link)(
  ({ theme }) => `
    margin: 0;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    color: ${theme.DS_palette.text.primary};
  `,
);
